<template>
  <b-container fluid>
    <b-row>
      <b-col lg="5">
        <iq-card class-name="iq-user-profile-block1">
          <template v-slot:body>
            <div class="user-details-block">
              <div class="user-profile text-center">
                <b-avatar size="150px" v-bind:src="
                  user.avatarUrl
                    ? user.avatarUrl +
                    '/' +
                    getAuthentication()
                    : ''
                "></b-avatar>
              </div>
              <div class="text-center mt-3">
                <h4>
                  <b>{{ user.name }} {{ user.lastname }}</b>
                </h4>
              </div>
              <hr />
              <ul class="
                    doctoe-sedual
                    d-flex
                    align-items-center
                    justify-content-between
                    p-0
                  ">
                <li v-for="(item, index) in user.userOrganizations" :key="index" class="text-center">
                  <OrganizationInfo :organization="item"></OrganizationInfo>
                </li>
              </ul>
            </div>
          </template>
        </iq-card>

        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title title-typography-color">
              <i class="far fa-eye"></i>
              {{ $t("public.views.Pages.Patient.Dashboard.nextDates") }}
            </h4>
          </template>
          <template v-slot:headerAction>
            <b-dropdown no-caret size="lg p-0" toggle-class="text-decoration-none" variant="link">
              <template v-slot:button-content>
                <span id="dropdownMenuButtons" class="dropdown-toggle p-0" data-toggle="dropdown">
                </span>
              </template>
              <b-dropdown-item href="#">
                <i class="ri-eye-fill mr-2"></i>{{ $t("public.views.Pages.Patient.Dashboard.see") }}
              </b-dropdown-item>
              <b-dropdown-item href="#">
                <i class="ri-delete-bin-6-fill mr-2"></i>{{ $t("public.views.Pages.Patient.Dashboard.delete") }}
              </b-dropdown-item>
              <b-dropdown-item href="#">
                <i class="ri-pencil-fill mr-2"></i>{{ $t("public.views.Pages.Patient.Dashboard.edit") }}
              </b-dropdown-item>
              <b-dropdown-item href="#">
                <i class="ri-printer-fill mr-2"></i>{{ $t("public.views.Pages.Patient.Dashboard.print") }}
              </b-dropdown-item>
              <b-dropdown-item href="#">
                <i class="ri-file-download-fill mr-2"></i>{{ $t("public.views.Pages.Patient.Dashboard.download") }}
              </b-dropdown-item>
            </b-dropdown>
          </template>
          <template v-slot:body>
            <v-data-table :headers="headers" :hide-default-footer="true" :items="appointments" :search="search"
              disable-pagination item-key="id">
              <template v-slot:item.professionals="{ item }">
                <div v-if="item.professionalLead">
                  <UserInfo :user="item.professionalLead"></UserInfo>
                </div>
              </template>
              <template v-slot:item.date="{ item }">
                <div v-if="item.startedAt">
                  {{ item.startedAt | adjustToTimezone("DD/MM/YYYY HH:mm") }}
                </div>
              </template>
              <template v-slot:item.actions="{ item }">
                <div v-if="item.billings">
                  <div v-for="(billing, index) in item.billings" :key="index">
                    <div v-if="
                      billing &&
                      user &&
                      billing.patient.id === user.id &&
                      billing.paymentPlace !== 'BEFORE_EVENT_ONLINE'
                    ">
                      <b-button v-if="item.join && item.online" variant="success" @click="joinVideoconference(item.id)">{{
                        $t("public.views.Pages.Patient.Dashboard.join")
                      }}
                      </b-button>
                    </div>
                    <div v-if="
                      billing &&
                      user &&
                      billing.patient.id === user.id &&
                      billing.paymentPlace === 'BEFORE_EVENT_ONLINE' &&
                      (!billing.payment ||
                        billing.payment.paymentStatus !== 'SUCCESS')
                    ">
                      <b-button v-if="
                        item.join &&
                        item.online &&
                        item.visitType.priceOnline !== 0
                      " variant="primary" @click="payBeforeEvent(user.id, item.id)">Pagar {{ item.visitType.price }}
                      </b-button>
                      <b-button v-if="
                        item.join &&
                        item.online &&
                        item.visitType.priceOnline === 0
                      " variant="success" @click="joinVideoconference(item.id)">{{
  $t("public.views.Pages.Patient.Dashboard.join")
}}
                      </b-button>
                    </div>
                    <div v-if="
                      billing &&
                      user &&
                      billing.patient.id === user.id &&
                      billing.paymentPlace === 'BEFORE_EVENT_ONLINE' &&
                      billing.payment &&
                      billing.payment.paymentStatus === 'SUCCESS'
                    ">
                      <b-button v-if="item.join && item.online" variant="success" @click="joinVideoconference(item.id)">{{
                        $t("public.views.Pages.Patient.Dashboard.join")
                      }}
                      </b-button>
                    </div>
                  </div>
                </div>
              </template>
            </v-data-table>
          </template>
        </iq-card>
        <!--CALENDAR -->
      </b-col>
      <b-col lg="7">
        <Schedule :dashboard="true" :idProfessional="idProfessional" :typeSchedule="typeSchedule"></Schedule>
      </b-col>
    </b-row>
    <b-modal id="modal-pay-dashboard" centered hide-footer size="sm">
      <template #modal-title>{{
        $t("public.views.Pages.Patient.Dashboard.modalPay.title")
      }}
      </template>
      <template #modal-cancel>{{
        $t("public.views.Pages.Patient.Dashboard.modalPay.btnCancel")
      }}
      </template>
      <div class="payment-btn-center">
        <i v-if="
          user &&
          user.userOrganizations &&
          user.userOrganizations[0] &&
          user.userOrganizations[0].paymentModePasarelaPaypal
        " id="btnPaypal" class="fab fa-paypal fa-4x fa-fw cursor-point" @click="showPaypalPayment"></i>
        <b-popover v-if="
          user &&
          user.userOrganizations &&
          user.userOrganizations[0] &&
          user.userOrganizations[0].paymentModePasarelaPaypal
        " :target="'btnPaypal'" placement="botton" triggers="hover focus">
          <template #title>{{
            $t("public.views.Pages.Patient.Dashboard.modalPay.btnPaypal")
          }}
          </template>
        </b-popover>
        <i v-if="
          user &&
          user.userOrganizations &&
          user.userOrganizations[0] &&
          user.userOrganizations[0].paymentModePasarelaStripe
        " id="btnStripe" class="fab fa-stripe fa-4x fa-fw cursor-point" @click="showStripePayment"></i>
        <b-popover v-if="
          user &&
          user.userOrganizations &&
          user.userOrganizations[0] &&
          user.userOrganizations[0].paymentModePasarelaStripe
        " :target="'btnStripe'" placement="botton" triggers="hover focus">
          <template #title>{{
            $t("public.views.Pages.Patient.Dashboard.modalPay.btnStripe")
          }}
          </template>
        </b-popover>
        <i v-if="
          user &&
          user.userOrganizations &&
          user.userOrganizations[0] &&
          user.userOrganizations[0].paymentModePasarelaWallet
        " id="btnWallet" class="fas fa-wallet fa-4x fa-fw cursor-point" @click="showCashPayment"></i>
        <b-popover v-if="
          user &&
          user.userOrganizations &&
          user.userOrganizations[0] &&
          user.userOrganizations[0].paymentModePasarelaWallet
        " :target="'btnWallet'" placement="botton" triggers="hover focus">
          <template #title>{{
            $t("public.views.Pages.Patient.Dashboard.modalPay.btnWallet")
          }}
          </template>
        </b-popover>
      </div>
    </b-modal>
    <b-modal id="modal-pay-dashboard-before-event" centered hide-footer size="sm">
      <template #modal-title>{{
        $t("public.views.Pages.Patient.Dashboard.modalPay.title")
      }}
      </template>
      <template #modal-cancel>{{
        $t("public.views.Pages.Patient.Dashboard.modalPay.btnCancel")
      }}
      </template>
      <div class="payment-btn-center">
        <i v-if="
          user &&
          user.userOrganizations &&
          user.userOrganizations[0] &&
          user.userOrganizations[0].paymentModePasarelaPaypal
        " id="btnPaypal" class="fab fa-paypal fa-4x fa-fw cursor-point" @click="showPaypalPaymentBeforeEvent"></i>
        <b-popover v-if="
          user &&
          user.userOrganizations &&
          user.userOrganizations[0] &&
          user.userOrganizations[0].paymentModePasarelaPaypal
        " :target="'btnPaypal'" placement="botton" triggers="hover focus">
          <template #title>{{
            $t("public.views.Pages.Patient.Dashboard.modalPay.btnPaypal")
          }}
          </template>
        </b-popover>
        <i v-if="
          user &&
          user.userOrganizations &&
          user.userOrganizations[0] &&
          user.userOrganizations[0].paymentModePasarelaStripe
        " id="btnStripe" class="fab fa-stripe fa-4x fa-fw cursor-point" @click="showStripePaymentBeforeEvent"></i>
        <b-popover v-if="
          user &&
          user.userOrganizations &&
          user.userOrganizations[0] &&
          user.userOrganizations[0].paymentModePasarelaStripe
        " :target="'btnStripe'" placement="botton" triggers="hover focus">
          <template #title>{{
            $t("public.views.Pages.Patient.Dashboard.modalPay.btnStripe")
          }}
          </template>
        </b-popover>
        <i v-if="
          user &&
          user.userOrganizations &&
          user.userOrganizations[0] &&
          user.userOrganizations[0].paymentModePasarelaWallet
        " id="btnWallet" class="fas fa-wallet fa-4x fa-fw cursor-point" @click="showCashPaymentBeforeEvent"></i>
        <b-popover v-if="
          user &&
          user.userOrganizations &&
          user.userOrganizations[0] &&
          user.userOrganizations[0].paymentModePasarelaWallet
        " :target="'btnWallet'" placement="botton" triggers="hover focus">
          <template #title>{{
            $t("public.views.Pages.Patient.Dashboard.modalPay.btnWallet")
          }}
          </template>
        </b-popover>
      </div>
    </b-modal>
    <b-modal id="modal-pay-dashboard-pending" centered hide-footer>
      <template #modal-title>{{
        $t("public.views.Pages.Patient.Dashboard.paymentPending")
      }}
      </template>
      <template #modal-cancel>{{
        $t("public.views.Pages.Patient.Dashboard.cancel")
      }}
      </template>

      <b-alert show variant="danger">{{
        $t("public.views.Pages.Patient.Dashboard.forbiddenAccess")
      }}
      </b-alert>
      <div v-for="(pay, index) in payPendings" :key="index">
        <b-form-group label-for="professionalModalCita">
          <template slot="label">{{
            $t("public.views.Pages.Patient.Dashboard.appoiment")
          }}:
          </template>
          <ul class="list-group">
            <li v-if="pay.professionalLead && pay.startedAt" class="list-group-item">
              {{ pay.professionalLead.name }}
              {{ pay.professionalLead.lastname }}

              {{ getStartDateFormatted(pay.startedAt) }}
            </li>
          </ul>
          <br />
          <b-row>
            <b-col>
              <div class="text-right">
                <b-button right variant="primary" @click="payShow(pay.patient.id, pay.eventId)">{{
                  $t("public.views.Pages.Patient.Dashboard.pay")
                }}
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-form-group>
      </div>
    </b-modal>
    <b-modal id="modal-surveys-pending" centered hide-footer>
      <template #modal-title>Encuestas pendientes</template>
      <template #modal-cancel>{{
        $t("public.views.Pages.Patient.Dashboard.cancel")
      }}
      </template>

      <div v-for="(survey, index) in surveysPending" :key="index">
        <b-form-group label-for="professionalModalCita">
          <template slot="label">Encuesta:</template>
          <ul class="list-group">
            <b-form-group label-for="professionalModalCita">
              <ul class="list-group">
                <li v-if="survey.surveyStoreName" class="list-group-item">
                  {{ survey.surveyStoreName }}
                  <span v-if="survey.date">({{ getStartDateFormatted(survey.date) }})</span>
                </li>
              </ul>
            </b-form-group>
          </ul>
          <br />
          <b-row>
            <b-col>
              <div class="text-right">
                <b-button right variant="success" @click="
                  completeSurvey(
                    survey.templateUuid,
                    survey.id,
                    survey.surveyStoreId
                  )
                ">Completar
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-form-group>
      </div>
    </b-modal>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import Schedule from "../../../components/schedule/Schedule";
import UserInfo from "../../../components/account/UserInfo";
import OrganizationInfo from "../../../components/account/OrganizationInfo";
import IqCard from "../../../components/xray/cards/iq-card";
import { xray } from "../../../config/pluginInit";
import moment from "moment";

import { mapActions, mapGetters } from "vuex";

import { loadStripe } from "@stripe/stripe-js";

import userService from "../../../services/user";
import utilsService from "../../../services/utils";
import scheduleService from "../../../services/schedule";
import surveyService from "../../../services/survey";

export default {
  name: "Dashboard",
  components: { IqCard, Schedule, UserInfo, OrganizationInfo },
  mounted() {
    xray.index();
    //Verificacion pay
    this.verifyPay();
    // Next cita
    this.getNextEvents(5);
    this.pollingNextEvents = setInterval(
      () => this.getNextEvents(5),
      60000
    );

    this.getUser();

    this.getSurveyPending();

    //Notificar que hay inpagos
    //this.getAllPlataformPayPending();
    utilsService.auditActivity({ action: "VIEW", module: "PATIENT_DASHBOARD", info: "" });
  },
  computed: {
    ...mapGetters({
      selectedUser: "Setting/userState",
    }),
  },
  methods: {
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    completeSurvey(uuid, id, surveyStoreId) {
      this.$router.push({
        name: "view.survey",
        query: {
          mode: "COMPLETED",
          uuid: uuid,
          surveyId: id,
          storeId: surveyStoreId,
        },
      });
    },
    getSurveyPending() {
      let self = this;
      this.$awn.asyncBlock(
        surveyService.getSurveyPending(),
        (response) => {
          if (response && response.data) {
            self.surveysPending = response.data;

            if (self.surveysPending.length !== 0) {
              self.$bvModal.show("modal-surveys-pending");
            }
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "surveyService.getSurveyPending",
            module: "view-pages-patient-dashboard",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organization: this.$route.query.organization
            })
          });
        },
        " "
      );
    },
    getStartDateFormatted(startedAt) {
      //:TODO HAY QUE PONER BIEN EL TEMA DEL TIMEZONE
      return moment(startedAt).subtract(60, "minutes").format("DD/MM/yyyy");
    },
    getAllPlataformPayPending() {
      let self = this;
      this.$awn.asyncBlock(
        scheduleService.getAllPlataformPayPending(0, 10),
        (response) => {
          self.payPendings = response.data.content;

          self.$bvModal.show("modal-pay-dashboard-pending");
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.getAllPlataformPayPending",
            module: "view-pages-patient-dashboard",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null
          });
        },
        " "
      );
    },
    //Pay
    async verifyPay() {
      if (
        this.$route.query.action !== undefined &&
        this.$route.query.mode !== undefined &&
        this.$route.query.tokenback !== undefined &&
        this.$route.query.token !== undefined &&
        this.$route.query.paymentId !== undefined &&
        this.$route.query.event !== undefined &&
        this.$route.query.PayerID !== undefined
      ) {
        if (this.$route.query.action === "success") {
          let data = {
            tokenPaypal: this.$route.query.token,
            paymentIdPaypal: this.$route.query.paymentId,
            payerIDPaypal: this.$route.query.PayerID,
          };

          this.paySuccess(
            this.$route.query.patientId,
            this.$route.query.event,
            this.$route.query.mode,
            this.$route.query.tokenback,
            data
          );
        }
      }
      if (
        this.$route.query.action !== undefined &&
        this.$route.query.mode !== undefined &&
        this.$route.query.tokenback !== undefined &&
        this.$route.query.token !== undefined
      ) {
        if (this.$route.query.action === "cancel") {
          let data = {
            tokenPaypal: this.$route.query.token,
            paymentIdPaypal: this.$route.query.paymentId,
            payerIDPaypal: this.$route.query.PayerID,
          };

          this.payCancel(
            this.$route.query.patientId,
            this.$route.query.event,
            this.$route.query.mode,
            this.$route.query.tokenback,
            data
          );
        }
      }
      if (
        this.$route.query.action !== undefined &&
        this.$route.query.mode !== undefined &&
        this.$route.query.tokenback !== undefined
      ) {
        if (this.$route.query.action === "success") {
          let data = {
            tokenPaypal: "",
            paymentIdPaypal: "",
            payerIDPaypal: "",
          };

          this.paySuccess(
            this.$route.query.patientId,
            this.$route.query.event,
            this.$route.query.mode,
            this.$route.query.tokenback,
            data
          );
        }
        if (this.$route.query.action === "cancel") {
          let data = {
            tokenPaypal: "",
            paymentIdPaypal: "",
            payerIDPaypal: "",
          };

          this.payCancel(
            this.$route.query.patientId,
            this.$route.query.event,
            this.$route.query.mode,
            this.$route.query.tokenback,
            data
          );
        }
      }
    },
    paySuccess(patientId, id, mode, token, data) {
      let self = this;

      this.$awn.asyncBlock(
        scheduleService.paySuccess(patientId, id, mode, token, data),
        (response) => {
          utilsService.auditActivity({
            action: "CREATE", module: "PATIENT_PAYMENT_SUCCESS", info: ""
          });
          self.getNextEvents(5);
          self.$notify({
            group: "notificacions",
            title: this.$i18n.t(
              "public.views.Pages.Patient.Schedule.notification.title"
            ),
            text: this.$i18n.t(
              "public.views.Pages.Patient.Schedule.notification.descPay"
            ),
            type: "success",
          });
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.paySuccess",
            module: "view-pages-patient-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              patientId: patientId, id: id, mode: mode, token: token, data: data
            })
          });
        },
        " "
      );
    },
    payCancel(patientId, id, mode, token, data) {
      let self = this;
      this.$awn.asyncBlock(
        scheduleService.payCancel(patientId, id, mode, token, data),
        (response) => {
          utilsService.auditActivity({ action: "CREATE", module: "PATIENT_PAYMENT_CANCEL", info: "" });
          this.$notify({
            group: "notificacions",
            title: this.$i18n.t(
              "public.views.Pages.Patient.Schedule.notification.error"
            ),
            text: this.$i18n.t(
              "public.views.Pages.Patient.Schedule.notification.descUnpay"
            ),
            type: "error",
          });
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.payCancel",
            module: "view-pages-patient-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              patientId: patientId, id: id, mode: mode, token: token, data: data
            })
          });
        },
        " "
      );
    },
    showStripePaymentBeforeEvent() {
      let self = this;

      this.$awn.asyncBlock(
        scheduleService.payStripeBeforeEvent(this.eventId, this.patientId),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PATIENT_PAYMENT_SUCCESS_STRIPE", info: "" });

            self.stripe = response.data;

            let stripeInit = loadStripe(self.stripe.publicKey);

            // wait for the promise to resolve first
            stripeInit.then((stripe) => {
              stripe
                .redirectToCheckout({
                  sessionId: self.stripe.idSession,
                })
                .then(function (result) {
                })
                .catch(function (error) {
                  console.error(error);
                });
            });

          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.payStripeBeforeEvent",
            module: "view-pages-patient-dashboard",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              eventId: this.eventId, patientId: this.patientId
            })
          });
        },
        " "
      );
    },
    showPaypalPaymentBeforeEvent() {
      let self = this;

      this.$awn.asyncBlock(
        scheduleService.payPaypalBeforeEvent(this.eventId, this.patientId),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PATIENT_PAYMENT_SUCCESS_PAYPAL", info: "" });
            self.paypal = response.data;
            window.location.href = self.paypal.url;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.payPaypalBeforeEvent",
            module: "view-pages-patient-dashboard",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              eventId: this.eventId, patientId: this.patientId
            })
          });
        },
        " "
      );
    },
    showCashPaymentBeforeEvent() {
      let self = this;

      this.$awn.asyncBlock(
        scheduleService.payCash(this.eventId, this.patientId),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PATIENT_PAYMENT_SUCCESS_WALLET", info: "" });
            self.getNextEvents(5);
            self.$bvModal.hide("modal-pay-dashboard");
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Patient.Dashboard.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Patient.Dashboard.notification.descPay"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          self.$swal(
            this.$i18n.t("public.views.Pages.Patient.Dashboard.errorSwal.text"),
            this.$i18n.t(
              "public.views.Pages.Patient.Dashboard.errorSwal.text1"
            ),
            this.$i18n.t("public.views.Pages.Patient.Dashboard.errorSwal.text2")
          );
          utilsService.auditErrorFrontent({
            info: "scheduleService.payCash",
            module: "view-pages-patient-dashboard",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              eventId: this.eventId, patientId: this.patientId
            })
          });
        },
        " "
      );
    },
    showStripePayment() {
      let self = this;

      this.$awn.asyncBlock(
        scheduleService.payStripe(this.eventId, this.patientId),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PATIENT_PAYMENT_SUCCESS_STRIPE", info: "" });
            self.stripe = response.data;

            let stripeInit = loadStripe(self.stripe.publicKey);
            // wait for the promise to resolve first
            stripeInit.then((stripe) => {
              stripe
                .redirectToCheckout({
                  sessionId: self.stripe.idSession,
                })
                .then(function (result) {
                })
                .catch(function (error) {
                  console.error(error);
                });
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.payStripe",
            module: "view-pages-patient-dashboard",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              eventId: this.eventId, patientId: this.patientId
            })
          });
        },
        " "
      );
    },
    showPaypalPayment() {
      let self = this;

      this.$awn.asyncBlock(
        scheduleService.payPaypal(this.eventId, this.patientId),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PATIENT_PAYMENT_SUCCESS_PAYPAL", info: "" });
            self.paypal = response.data;
            window.location.href = self.paypal.url;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.payPaypal",
            module: "view-pages-patient-dashboard",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              eventId: this.eventId, patientId: this.patientId
            })
          });
        },
        " "
      );
    },
    showCashPayment() {
      let self = this;

      this.$awn.asyncBlock(
        scheduleService.payCash(this.eventId, this.patientId),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PATIENT_PAYMENT_SUCCESS_WALLET", info: "" });
            self.getNextEvents(5);
            self.$bvModal.hide("modal-pay-dashboard");
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Patient.Dashboard.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Patient.Dashboard.notification.descPay"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          self.$swal(
            this.$i18n.t("public.views.Pages.Patient.Dashboard.errorSwal.text"),
            this.$i18n.t(
              "public.views.Pages.Patient.Dashboard.errorSwal.text1"
            ),
            this.$i18n.t("public.views.Pages.Patient.Dashboard.errorSwal.text2")
          );
          utilsService.auditErrorFrontent({
            info: "scheduleService.payCash",
            module: "view-pages-patient-dashboard",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              eventId: this.eventId, patientId: this.patientId
            })
          });
        },
        " "
      );
    },
    payShow(patientId, eventId) {
      this.patientId = patientId;
      this.eventId = eventId;
      this.$bvModal.hide("modal-pay-dashboard-pending");
      this.$bvModal.show("modal-pay-dashboard");
    },
    payBeforeEvent(patientId, eventId) {
      this.patientId = patientId;
      this.eventId = eventId;
      this.$bvModal.show("modal-pay-dashboard-before-event");
    },
    checkDeviceAndRedirectMobileApp() {
      var is_uiwebview = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
        navigator.userAgent
      );
      var is_safari_or_uiwebview = /(iPhone|iPod|iPad).*AppleWebKit/i.test(
        navigator.userAgent
      );

      if (is_uiwebview || is_safari_or_uiwebview) {
        window.location.href =
          "https://apps.apple.com/us/app/cita-io/id1643449872";
      }

      if (navigator.userAgent.toLowerCase().indexOf("iphone") > -1) {
        window.location.href =
          "https://apps.apple.com/us/app/cita-io/id1643449872";
      }

      if (navigator.userAgent.toLowerCase().indexOf("ipad") > -1) {
        window.location.href =
          "https://apps.apple.com/us/app/cita-io/id1643449872";
      }
      if (this.$device && this.$device.os_name && this.$device.os_name.name) {
        if (this.$device.os_name.name.includes("iOS")) {
          window.location.href =
            "https://apps.apple.com/us/app/cita-io/id1643449872";
        }
      }
    },
    joinVideoconference(eventId) {
      this.getEventJoinVideoconference(eventId);
    },
    getEventJoinVideoconference(eventId) {
      let self = this;
      //this.checkDeviceAndRedirectMobileApp();
      this.$awn.asyncBlock(
        scheduleService.getEvent(eventId),
        (response) => {
          if (response) {
            if (
              response.data.paymentPlace !== "BEFORE_EVENT_ONLINE" ||
              response.data.payment
            ) {
              utilsService.auditActivity({ action: "VIEW", module: "JOIN_EVENT", info: "" });
              let href =
                process.env.VUE_APP_BASE_URL_WEBAPP + "auth/room?eventId="+ 
                eventId;
              window.open(href, "_blank");
            } else {
              this.$notify({
                group: "notificacions",
                title: this.$i18n.t(
                  "public.views.Pages.Patient.Dashboard.notification.error"
                ),
                text: this.$i18n.t(
                  "public.views.Pages.Patient.Dashboard.notification.descTalkOrganization"
                ),
                type: "error",
              });
            }
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.getEvent",
            module: "view-pages-patient-dashboard",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              eventId: this.eventId
            })
          });
        },
        " "
      );
    },
    async getUser() {
      let self = this;

      this.$awn.asyncBlock(
        userService.get(localStorage.getItem("userId")),
        (response) => {
          if (response) {
            self.user = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "userService.get",
            module: "view-pages-patient-dashboard",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              userId: localStorage.getItem("userId")
            })
          });
        },
        " "
      );
    },
    async getNextEvents(number) {
      let self = this;

      scheduleService
        .getNextEvents(number)
        .then((response) => {
          if (response) {
            let result = [];

            // Quitamos el telefono
            response.data.forEach((appointment) => {
              appointment.professionalLead.phone = "";

              result.push(appointment);
            });

            self.appointments = result;
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.getNextEvents",
            module: "view-pages-patient-dashboard",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              number: number
            })
          });
        });
    },
  },
  data() {
    return {
      //Survey pending
      surveysPending: [],
      //Pay
      stripe: {
        publicKey: "",
        idSession: "",
      },
      paypal: {
        url: "",
      },
      patientId: "",
      eventId: "",
      //--
      user: {},
      // Next cita
      pollingNextEvents: null,

      search: "",
      headers: [
        {
          text: this.$i18n.t(
            "public.views.Pages.Patient.Dashboard.professional"
          ),
          value: "professionals",
        },
        {
          text: this.$i18n.t("public.views.Pages.Patient.Dashboard.date"),
          value: "date",
        },
        {
          text: "",
          value: "actions",
        },
      ],
      appointments: [],
      // Calendar
      typeSchedule: "PATIENT",
      idProfessional: null,

      payPendings: [],
    };
  },
  beforeDestroy() {
    clearInterval(this.pollingNextEvents);
  },
};
</script>
